<template>
  <div>
        <header>
          <div class="headerOne">
               <i class="el-icon-arrow-left" @click="$router.go(-1)"></i>
              <!-- <img src="../../assets/images/returnOne.png" @click="$router.go(-1)"> -->
              <span class="buss">个性签名</span>
              <span class="suceesOne" @click="openIndicatorWithText()">完成</span>
          </div>
      </header>
      <div class="import">
          <span>签名 :</span>
         <textarea type="text" placeholder="请输入" cols="10"  rows="3" @input="numberThree" maxlength="100"
         v-model="desc">   
         </textarea>
      </div>
      <div class="oneHub">
          <span class="oneRwo">{{testOne}}</span>
          <span>/100</span>
      </div>
  </div>
</template>
<script>
import {Indicator} from 'mint-ui'

    export default{
        data(){
            return{
                msg:"签名",
                testOne:100,
                desc:""
            }
        },

        computed:{
                    wsWbsocket(){
                        return this.$store.state.wsWbsocket;
                        }
                },  
        methods:{
            numberThree(){
            var txtVal=this.desc.length;
            this.testOne=100-txtVal
          
        },
        openIndicatorWithText(){
              var infoOne='"'+'info'+'":'+'"'+this.desc+'"';
              ws.send('{"action":"UpdateUserInfoByUid",'+infoOne+'}');
                ws.onmessage = (res)=>
                  {
                    var obj = JSON.parse(res.data);

                    if(obj.action=="UpdateUserInfoByUid"){
                          console.log(1111,obj)
                          if(obj.s==0){
                             this.$store.state.userinfo.info=this.desc     
                                     
                                 this.$router.push({path:"/personage"}) 
                          }else if(obj.s==1029){
                              
                          }
                    }
                  }

                  
         }
        }
    }
</script>
<style scoped>
.el-icon-arrow-left{
    font-size: 0.7rem;
    line-height:1.6rem;
     margin-left: 0.2rem
}
header{
    height:1.6rem !important;
    width: 100%;
    border-bottom: 1px solid rgba(0,0,0,0.20);
    position: relative;
}
 .headerOne{
         height:1.6rem;
     font-size: 0.55;  
     position: relative;
     }
 .headerOne img{
    display: inline-block;
    margin-top: 0.3rem
 }
  .headerOne img:nth-child(1){
      margin-left: 0.2rem
  }
  .headerOne .buss{
      display: inline-block;
      font-size: 0.55rem !important;
        position:absolute;
        left:50%;
        top:50%;
        /* transform: translate(-50%,-50%); */
      
  }
  header{
    height:1rem;
    width: 100%;
    border-bottom: 1px solid rgba(0,0,0,0.20);
    position: relative;
}
.suceesOne{
    font-size: 0.55rem;
    position: absolute;
    top: 0.47rem;
    left:8.3rem;
    color: green

}
 .headerOne{
     font-size: 0;  
     }
 .headerOne img{
    display: inline-block;
    margin-top: 0.3rem
 }
  .headerOne img:nth-child(1){
      margin-left: 0.2rem
  }
  .headerOne .buss{
      display: inline-block;
      font-size: 0.55rem;
        position:absolute;
        left:50%;
        top:50%;
        transform: translate(-50%,-50%);
  }
  .import{
      margin-top: 0.5rem
  }
  .import span{
      color: rgba(0,0,0,0.90);
      font-size: 0.55rem;
      margin-left: 0.4rem;
      vertical-align: top;
  }
  .import textarea{
      width:7.5rem;
      height: 4rem;
      outline: none;
      border: none;
      font-size: 0.55rem;
      display: inline-block;
      border-radius: 0.1rem;
     padding-top: 0.05rem;
     color: rgba(0,0,0,0.90);
     background: rgba(0,0,0,0.20);
  }
  .oneHub{
      font-size: 0;
      color: rgba(0,0,0,0.20);
      position: absolute;
      left:7.2rem;
      top:5.5rem
  }
   .oneHub span{
       font-size: 0.5rem
   }
</style>


// WEBPACK FOOTER //
// src/components/change/signature.vue